<!--  -->
<template>
  <div class="cen">
    <dl class="navigation">
      <div class="dddiv">
        <div class="dd">1<span>户籍信息</span></div>
      </div>
      <p></p>
      <div class="dddiv">
        <div class="dd">2<span>户籍附件</span></div>
      </div>
      <p></p>
      <div class="dddiv">
        <div class="dd">3<span>房产信息</span></div>
      </div>
      <p></p>
      <div class="dddiv">
        <div class="dd li_special">4<span>学校信息</span></div>
      </div>
      <p></p>
      <div class="dddiv">
        <div class="dd">5<span>提交信息</span></div>
      </div>
    </dl>
    <van-form @submit="next" scroll-to-error>
      <!-- 选择学段 -->
      <van-field
        required
        readonly
        clickable
        name="选择学段"
        :value="ruleForm5.xueduan"
        label="选择升学学段"
        placeholder="请选择升学学段"
        @click="tshow1 = true"
        :rules="rules.xueduan"
        input-align="right"
        @change="xzxueduan"
        right-icon="arrow"
      />
      <van-popup v-model="tshow1" position="bottom">
        <van-picker
          show-toolbar
          :columns="schoolType"
          value-key="name"
          @confirm="onConfirm1"
          @cancel="tshow1 = false"
          @change="xzxueduan"
        />
      </van-popup>
      <div class="hang">
        <span class="red"
          >此选择与学生校验处升学学段一致，如选择错误请回到首页删除重建</span
        >
      </div>
      <!-- 选择学校 -->
      <van-field
        required
        readonly
        clickable
        name="选择学校"
        :value="ruleForm5.school"
        label="选择学校"
        placeholder="请选择学校"
        @click="tshow2 = true"
        :rules="rules.schoolid"
        input-align="right"
        right-icon="arrow"
      />
      <van-popup v-model="tshow2" position="bottom">
        <van-picker
          show-toolbar
          :columns="schoollist"
          value-key="schoolName"
          @confirm="onConfirm2"
          @cancel="tshow2 = false"
        />
      </van-popup>
      <!-- 提交按钮 -->
      <div style="margin: 0.64rem" class="dbbtn">
        <van-button class="btn" native-type="button" @click="back"
          >返回</van-button
        >
        <van-button class="btn zuo" :loading="codeDisabled" native-type="submit"
          >保存并下一步</van-button
        >
      </div>
      <div class="bgdiv"></div>
    </van-form>
    <notices></notices>
  </div>
</template>
<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import { mapGetters } from "vuex";
import "element-ui/lib/theme-chalk/index.css";
import sessionUtils from "@/utils/session-store-utils";
import { getschool, selectone, savefour, selectfour } from "@/api/news";
import notices from "../components/notices.vue";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: { notices },
  data() {
    //这里存放数据
    return {
      firstget: "0",
      tshow1: false, //选择学段弹窗
      tshow2: false, //选择学校弹窗
      codeDisabled: false,
      loading: false,
      cha1: 0,
      cha2: 0,
      schoolType: [
        {
          name: "小学",
          id: "0",
          disabled: true,
        },
        {
          name: "初中",
          id: "1",
          disabled: true,
        },
      ],
      schoollist: [], //学校列表(总)
      slist: [], //学校列表（根据学段）
      xdid: "", //查询读取出的学段id
      ruleForm1: {},
      ruleForm5: {
        xueduan: "", //学段
        xdid: "", //学段id
        school: "", //学校
        schoolid: "", //学校id
        mold: 1,
        step: 5,
      },
      tjpan: 0,
      rules: {
        xueduan: [{ required: true, message: "请选择学段", trigger: "blur" }],
        schoolid: [{ required: true, message: "请选择学校", trigger: "blur" }],
      },
    };
  },
  //监听属性 类似于data概念
  computed: {
    ...mapGetters(["leftBtnClick", "rightBtnClick"]),
  },
  //监控data中的数据变化
  watch: {
    leftBtnClick(clickdic) {
      console.log(clickdic);
      this.$router.push({
        path: "/property",
      });
    },
    rightBtnClick(clickdic) {
      // console.log(clickdic);
      sessionStorage.setItem("from", JSON.stringify(this.from));
      this.$router.push({
        path: "/record",
      });
    },
  },
  created() {
    this.loading = true;
    if (JSON.parse(sessionStorage.getItem("from1"))) {
      this.ruleForm1 = JSON.parse(sessionStorage.getItem("from1"));
      this.cha1 = 1;
      if (this.cha1 == "1" && this.cha2 == "1") {
        this.loading = false;
      }
    } else {
      this.selectone();
    }

    this.getschool();
    // if (JSON.parse(sessionStorage.getItem("xueduan"))) {
    //   this.xdid = JSON.parse(sessionStorage.getItem("xueduan"));
    //   console.log(this.xdid);
    //   this.schoolType.forEach((e) => {
    //     if (e.id == this.xdid) {
    //       e.disabled = false;
    //     }
    //   });
    // }
    this.panxueduan();
    console.log(sessionStorage);
  },
  methods: {
    panxueduan() {
      const year = Number(
        this.getyear(JSON.parse(sessionStorage.getItem("idno")))
      );
      console.log(year);
      if (year >= Number(20130831) && year <= Number(20180831)) {
        this.schoolType.forEach((e) => {
          if (e.id == "0") {
            e.disabled = false;
          }
        });
      } else if (year >= Number(20080901) && year <= Number(20130901)) {
        this.schoolType.forEach((e) => {
          if (e.id == "1") {
            e.disabled = false;
          }
        });
      }
    },
    //获取身份证年份
    getyear(idCard) {
      let birthday = "";
      if (idCard != null && idCard != "") {
        if (idCard.length == 15) {
          birthday = "19" + idCard.substr(6, 6);
        } else if (idCard.length == 18) {
          birthday = idCard.substr(6, 8);
        }
      }
      return birthday;
    },
    //选择学段
    onConfirm1(s) {
      console.log(s);
      this.tshow1 = false;
      this.ruleForm5.xueduan = s.name;
      this.ruleForm5.xdid = s.id;
      this.xzxueduan(s.id);
    },
    //选择学校
    onConfirm2(s) {
      console.log(s);
      this.tshow2 = false;
      this.ruleForm5.school = s.schoolName;
      this.ruleForm5.schoolid = s.id;
    },
    //用户须知公共弹窗
    tan() {
      this.$notice(true);
    },
    //获取学校
    async getschool() {
      const res = await getschool();
      console.log(res);
      if (res.code == "200") {
        // this.slist = res.data;
        res.data.forEach((e) => {
          if (e.state == "0") {
            this.slist.push(e);
          }
        });
        // res.data.forEach((e) => {
        //   if (e.schoolType == this.xdid) {
        //     this.schoollist.push(e);
        //   }
        // });
        this.setsession();
      } else {
        this.$toast("获取学校失败," + res.msg);
      }
    },
    //读取本地存储
    setsession() {
      if (JSON.parse(sessionStorage.getItem("from4"))) {
        const s = JSON.parse(sessionStorage.getItem("from4"));
        this.ruleForm5 = s;
        this.cha2 = 1;
        if (this.cha1 == "1" && this.cha2 == "1") {
          this.loading = false;
        }
        this.xzxueduan(this.ruleForm5.xdid, 1);
        this.schoolType.forEach((e) => {
          if (e.id == this.ruleForm5.xdid) {
            this.ruleForm5.xueduan = e.name; //学校id
          }
        });
        this.schoollist.forEach((e) => {
          if (e.id == this.ruleForm5.schoolid) {
            this.ruleForm5.school = e.schoolName; //学校id
          }
        });
      } else {
        this.selectfour();
      }
    },
    //选择学校
    xzschool(s) {
      console.log(s);
      this.ruleForm5.schoolid = s;
    },
    //选择学段
    xzxueduan(s, i) {
      console.log(s);
      this.ruleForm5.xdid = s;
      this.schoollist = [];
      this.slist.forEach((e) => {
        if (e.schoolType == s) {
          this.schoollist.push(e);
        }
      });
      if (i != 1) {
        this.ruleForm5.schoolid = "";
        this.ruleForm5.school = "";
      }
    },
    back() {
      this.$router.push({
        path: "/property",
      });
    },
    next() {
      const a = JSON.parse(sessionStorage.getItem("fourid"));
      if (
        (a === "undefined" || a == null || a === "") &&
        this.firstget == "0"
      ) {
        this.selectfour1();
      } else {
        if (this.tjpan == 0) {
          this.submit();
        }
      }
    },
    //保存
    async submit() {
      this.codeDisabled = true;
      this.tjpan = 1;
      const res = await savefour({
        id: JSON.parse(sessionStorage.getItem("fourid")), //主键id
        userInfoId: JSON.parse(sessionStorage.getItem("userInfoId")), //用户报名id
        academicStage: this.ruleForm5.xdid, //学段
        schoolId: this.ruleForm5.schoolid, //学校id
      });
      this.tjpan = 0;
      this.codeDisabled = false;
      if (res.code == "200") {
        this.$toast("保存成功");
        sessionStorage.setItem("from4", JSON.stringify(this.ruleForm5));
        sessionStorage.setItem("fourid", JSON.stringify(res.data.id));
        this.$router.push({
          path: "/submit",
          // query: { typeId: this.typeId, householdId: this.householdId },
        });
      } else {
        this.$toast("提交失败", res.msg);
      }
    },
    //查询返显
    async selectfour() {
      this.$toast.loading();
      const res = await selectfour({
        userInfoId: JSON.parse(sessionStorage.getItem("userInfoId")), //报名id
      });
      console.log(res);
      this.$toast.clear();
      this.cha2 = 1;
      if (this.cha1 == "1" && this.cha2 == "1") {
        this.loading = false;
      }
      if (res.code == "200") {
        const s = res.data;
        this.ruleForm5.xdid = s.academicStage; //学段
        this.xzxueduan(this.ruleForm5.xdid);
        console.log(this.ruleForm5.schoolid);
        this.ruleForm5.schoolid = s.schoolId; //学校id
        this.schoolType.forEach((e) => {
          if (e.id == this.ruleForm5.xdid) {
            this.ruleForm5.xueduan = e.name; //学校id
          }
        });
        this.schoollist.forEach((e) => {
          if (e.id == this.ruleForm5.schoolid) {
            this.ruleForm5.school = e.schoolName; //学校id
          }
        });
        sessionStorage.setItem("from4", JSON.stringify(this.ruleForm5));
        sessionStorage.setItem("fourid", JSON.stringify(res.data.id));
      } else {
        this.$toast("查询失败," + res.msg);
      }
    },
    //查询返显1
    async selectfour1() {
      this.$toast.loading();
      const res = await selectfour({
        userInfoId: JSON.parse(sessionStorage.getItem("userInfoId")), //报名id
      });
      console.log(res);
      this.$toast.clear();
      if (res.code == "200") {
        if (res.data) {
          sessionStorage.setItem("fourid", JSON.stringify(res.data.id));
          this.next();
        } else {
          this.firstget = "1";
          this.next();
        }
      } else {
        this.$toast("查询失败," + res.msg);
      }
    },
    //查询返显one
    async selectone() {
      const res = await selectone({
        userInfoId: JSON.parse(sessionStorage.getItem("userInfoId")), //报名id
      });
      console.log(res);
      this.loading = false;
      if (res.code == "200") {
        const s = res.data;
        this.ruleForm1.name = s.studentName; //学生姓名
        this.ruleForm1.idCard = s.studentIdcard; //学生身份证号
        this.ruleForm1.gender = s.studentGender == "0" ? "男" : "女"; //学生性别
        this.ruleForm1.nation = s.studentNation; //学生民族
        this.ruleForm1.birthDate = s.studentBirthday; //学生出生日期
        this.ruleForm1.yuanyinid = s.xsylhjrgx; //学生与落户籍人关系
        this.ruleForm1.yuanyin1 = s.xsylhjrgxyy; //学生与落户籍人关系原因
        this.ruleForm1.istwins = s.isTwins; //是否是双胞胎（1：是，2：否）
        this.ruleForm1.tname = s.twinName; //双胞胎姓名
        this.ruleForm1.tidno = s.twinIdcard; //双胞胎身份证号
        this.ruleForm1.isonehk = s.xshfmsfzyghkb; //学生和父母是否在一个户口本（1：是，2：否）
        this.ruleForm1.ishjbd = s.xshjsfzbd; //学生户籍是否在本地（1：是，2：否）
        this.ruleForm1.isfc = s.hasHouse; //有无房产
        this.ruleForm1.isjzz = s.hasResidencePermit; //有无居住证
        this.ruleForm1.yesdate = s.residencePermitLifespan; //居住证有效期
        // this.ruleForm1.stardate =
        //   this.ruleForm1.yesdate.length > 0 ? this.ruleForm1.yesdate[0] : ""; //居住证有效期开始时间
        // this.ruleForm1.enddate =
        //   this.ruleForm1.yesdate.length > 1 ? this.ruleForm1.yesdate[1] : ""; //居住证有效期结束时间
        this.ruleForm1.jzaddress = s.residencePermitAddress; //居住证上现居住地址
        this.ruleForm1.hjpcsid = s.studentDomicilePolice; //学生户籍地派出所
        this.ruleForm1.hjszd = s.domicileAddress; //户籍详细地址
        this.ruleForm1.detailedAddress = s.nowAddress; //现居住详细地址
        this.ruleForm1.special = s.tsyf; //特殊优抚
        this.ruleForm1.geigeiname = s.ggjjname; //哥哥/姐姐姓名
        this.ruleForm1.geigeiidno = s.ggjjidcard; //哥哥/姐姐身份证号
        this.ruleForm1.ggschool = s.ggjjschool; //哥哥/姐姐学校
        this.ruleForm1.ggclass = s.ggjjgrade; //哥哥/姐姐年级
        this.ruleForm1.isgghkb = s.sfyggjjzyghkb; //是否和哥哥姐姐在同一个户口本
        this.ruleForm1.firstGuardianName = s.guardionOneName; //监护人（一）姓名
        this.ruleForm1.firstGuardianRelationshipid = s.guardionOneRelation; //监护人（一）关系
        this.ruleForm1.firstGuardianIdcardTypeid = s.guardionOneDocumentType; //监护人（一）证件类型
        this.ruleForm1.firstGuardianIdcard = s.guardionOneDocumentNumber; //监护人（一）证件号码
        this.ruleForm1.firstGuardianPhone = s.guardionOneDocumentPhone; //监护人（一）联系电话
        this.ruleForm1.secondGuardianName = s.guardionTwoName; //监护人（二）姓名
        this.ruleForm1.secondGuardianRelationshipid = s.guardionTwoRelation; //监护人（二）关系
        this.ruleForm1.secondGuardianIdcardTypeid = s.guardionTwoDocumentType; //监护人（二）证件类型
        this.ruleForm1.secondGuardianIdcard = s.guardionTwoDocumentNumber; //监护人（二）证件号码
        this.ruleForm1.secondGuardianPhone = s.guardionTwoDocumentPhone; //监护人（二）联系电话
      } else {
        this.$toast(res.msg);
      }
    },
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
    <style lang="less" scoped>
/*@import url(); 引入公共css类*/
.hang {
  width: 100%;
  height: 1rem;
  line-height: 1rem;
  font-size: 0.48rem;
  background-color: #f3f3f3;
  .red {
    color: red;
  }
}
.cen {
  width: 100%;
}
.dbbtn {
  position: fixed;
  bottom: 1rem;
  width: 100%;
}
.zuo {
  margin-left: 1rem;
}
.navigation {
  width: 90%;
  height: 1.5rem;
  margin: 1.5rem auto;
  margin-bottom: 2.2rem;
  display: flex;
  justify-content: space-between;
  position: relative;
}
.navigation p {
  width: 1.2rem;
  height: 0.04rem;
  background: #b2dcd8;
  position: relative;
  border: 0.04rem dashed #fff;
  top: -0.2rem;
}
.navigation .dddiv {
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 2.4rem;
  border: 0.04rem dashed #0f9386;
  display: flex;
  align-items: center;
  justify-content: center;
}
.navigation .dd {
  width: 1.2rem;
  height: 1.2rem;
  text-align: center;
  line-height: 1.2rem;
  background: #b2dcd8;
  border-radius: 0.6rem;
  font-size: 0.52rem;
  color: #fff;
  border: 0.04rem solid #fff;
  position: relative;
}
.navigation .dd span {
  display: block;
  width: 2rem;
  height: auto;
  position: absolute;
  top: 1.5rem;
  left: -0.4rem;
  font-family: PingFangSC-Regular;
  font-size: 0.48rem;
  color: #ccc;
  letter-spacing: 0.006rem;
}
.navigation .li_special {
  background: #0f9386;
}
.navigation .li_special span {
  color: #000;
}
.btn {
  width: 4.8rem;
  background: #0f9386;
  color: #fff;
  border-radius: 0.2rem;
}
</style>